import * as React from 'react';
import PeopleIcon from '@material-ui/icons/People';
import CardWithIcon from './CardWithIcon';

const UserCount = ({ value }) => {
    return (
        <CardWithIcon
            to="/users"
            icon={PeopleIcon}
            title="Users"
            subtitle={value}
        />
    );
};

export default UserCount;